// @ts-nocheck
import Vue from 'vue';
import Vuex from 'vuex';
import { auth, getAuthToken } from './modules/auth.js';
import { users } from './modules/users.js';
import { roles } from './modules/roles.js';
import { permissions } from './modules/permissions.js';
import { logs } from './modules/logs.js';
import { user_profiles } from './modules/user_profiles.js';
import { visitors } from './modules/visitors.js';
import { countries } from './modules/countries.js';
import { genders } from './modules/genders.js';
import { positions } from './modules/positions.js';
import { membership_manners } from './modules/membership_manners.js';
import { statuses } from './modules/statuses.js';
import { zones } from './modules/zones.js';
import { marital_statuses } from './modules/marital_statuses.js';
import { ministries } from './modules/ministries.js';
import { organisations } from './modules/organisations.js';
import { services } from './modules/services.js';
import { heard_about_us_from } from './modules/heard_about_us_from.js';
import { service_types } from './modules/service_types.js';
import { service_activities_templates } from './modules/service_activities_templates.js';
import { sidebar } from './modules/sidebar.js';
import { vue_tables } from './modules/vue_tables.js';
import { onboardings } from './modules/onboardings.js';
import { weekdays } from './modules/weekdays.js';
import { giving_types } from './modules/giving_types.js';
import { head_count_types } from './modules/head_count_types.js';
import { organisation_tasks } from './modules/organisation_tasks.js';
import { service_activities } from './modules/service_activities.js';
import { files } from './modules/files.js';
import { system_settings } from './modules/system_settings.js';
import { notifications } from './modules/notifications.js';
import { alerts } from './modules/alerts.js';
import { denominations } from './modules/denominations.js';
import { rosters } from './modules/rosters.js';
import { membership_self_registrations } from './modules/membership_self_registrations.js';
import { sms } from './modules/sms.js';
import { payments } from './modules/payments.js';
import groups from './modules/groups.js';
import organisation_dashboard from './modules/organisation_dashboard.js';
import preferences from './modules/preferences.js';
import live_chats from './modules/live_chats.js';
import screen from './modules/screen';
import follow_ups from './modules/follow_ups';
import financial_approvals from './modules/financial_approvals';
import financial_periods from './modules/financial_periods';
import financial_budgets from './modules/financial_budgets';
import financial_requests from './modules/financial_requests';
import branch_management from './modules/branch_management';
import { membership_requests } from './modules/membership_requests.js';
import { followers } from './modules/followers.js';
import { fundraisings } from './modules/fundraisings.js';
import { posts } from './modules/posts.js';
import { gotedoEditor } from './modules/gotedo_editor.js';
import { formCaches } from './modules/form_caches.js';
import { wellKnown } from './modules/well_known.js';
import { subscription } from './modules/subscription.js';

import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
import { getRemoteResponsiveImage } from '../shared/utils.js';
import { sortBy } from 'lodash';
import i18next from 'i18next';

Vue.use(Vuex);
const ls = new SecureLS({ isCompression: false });
const inProduction = process.env.NODE_ENV === 'production';
const inDevelopment = process.env.NODE_ENV === 'development';
const inStagingMode = process.env.VUE_APP_IN_STAGING_MODE === 'true';

const store = new Vuex.Store({
  state() {
    return {
      isProduction: inProduction,
      inProduction,
      inDevelopment,
      isDevelopment: inDevelopment,
      inStagingMode,
      onlinePresence: true,
      gtmID: `${process.env.NODE_ENV === 'production' ? 'GTM-56SGN89' : 'GTM-M7W36ZV'}`,
      // 5 minutes (300 seconds) is okay for most request.
      // Override the value for requests which might take longer
      httpTimeout: 5 * 60 * 1000,
      currentYear: null,
      allowedImageMimeTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
      allowedDocMimeTypes: ['application/pdf'],
      allowedDownloadableFilesMimeTypes: [
        'text/plain',
        'text/csv',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.ms-powerpoint',
        'application/zip',
        'application/x-7z-compressed',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      ],
      allowedMigrationTemplateMimeTypes: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ],
      maxDocSize: 500,
      maxDownloadableFileSize: 1048576, //1048576 KB === 1 GB
      // Refresh token if current time is less than 60 seconds to expiration time
      allowYahooAccounts: false,
      defaultLogo: '/img/logos/GOTEDO-LOGO-DESIGN-V1-LANDSCAPE-LOGO-ONLY-H150px.png',
      appName: 'Gotedo Church Management Software',
      pageSubtitle: null,
      secondaryBackButtonTo: null,
      buildVersion: '',
      currentRoute: null,
      topActionsOptions: { visible: false, options: undefined },
      httpProgress: {
        upload: 0,
        download: 0,
      },
      socket: {
        socketSession: {
          id: null,
        },
        isConnected: false,
      },
      defaultCountry: undefined,
      hasJoinedGlobalAdminsRoom: false,
    };
  },
  getters: {
    defaultCountry: (state) => state.defaultCountry,
    getDefaultLogo: (state) => state.defaultLogo,
    getAppName: (state) => state.appName,
    isYahooAccountsAllowed: (state) => state.allowYahooAccounts,
    apiBaseUrlOverride: () => () => {
      return localStorage.getItem('API_BASE_URL_OVERRIDE');
    },
    getOnlinePresence: (state) => {
      return state.onlinePresence;
    },
    isUsingLocalApiServer: (state, getters) => () => {
      /** @type {URL} */
      const resolvedApiBaseUrl = getters.resolvedApiBaseUrl();
      return /(localhost|127.0.0.1|192.168)/.test(resolvedApiBaseUrl.hostname);
    },
    resolvedApiBaseUrl: (state, getters) => () => {
      /** @type {string|null} */
      const apiBaseUrlOverride = getters.apiBaseUrlOverride();
      const defaultApiBaseUrl = process.env.VUE_APP_API_BASE_URL;
      return new URL(apiBaseUrlOverride ? apiBaseUrlOverride : defaultApiBaseUrl);
    },
    resolvedGotedoAccountsBaseUrl: (state, getters) => () => {
      const apiBaseUrlOverride = getters.apiBaseUrlOverride();
      if (inProduction && !inStagingMode) {
        return 'https://accounts.gotedo.com';
      }
      if (inStagingMode && !apiBaseUrlOverride) {
        return 'https://accounts.gotedostaging.uk';
      }
      // Don't join with a slash (/)
      return [getters.resolvedApiBaseUrl(), 'accounts'].join('');
    },
    rootURL: (state, getters) => () => {
      return getters.resolvedApiBaseUrl().host;
    },
    getHttpProtocol: (_state, getters) => () => {
      if (getters.isUsingLocalApiServer()) {
        return 'http://';
      }
      return 'https://';
    },
    getSocketProtocol: (state, getters) => () => {
      if (getters.isUsingLocalApiServer()) {
        return 'ws://';
      }
      return 'wss://';
    },
    getCurrentYear: () => new Date().getFullYear(),
    getGtmID: (state) => state.gtmID,
    getRootURL: (state, getters) => () => {
      return getters.resolvedApiBaseUrl().href.replace(/\/$/, '');
    },
    getBaseURL: (state, getters) => () => getters.getRootURL(),
    gotedoLocale: () => () => window.localStorage.getItem('gotedo_locale'),
    getWebsocketURL: (state, getters) => () => `${getters.getSocketProtocol()}${getters.rootURL()}`,
    getHttpTimeout: (state) => state.httpTimeout,
    getHttpOptions: (state, getters) => () => {
      const authToken = getAuthToken();
      return {
        baseURL: getters.getBaseURL(),
        timeout: getters.getHttpTimeout,
        headers: authToken?.length
          ? {
              Authorization: `Bearer ${authToken}`,
            }
          : {},
      };
    },
    getAllowedImageMimeTypes: (state) => state.allowedImageMimeTypes,
    getAllowedDocMimeTypes: (state) => state.allowedDocMimeTypes,
    getAllowedDownloadableFilesMimeTypes: (state) => state.allowedDownloadableFilesMimeTypes,
    getAllowedMigrationTemplateMimeTypes: (state) => state.allowedMigrationTemplateMimeTypes,
    getAllowedMigrationTemplateMimeTypesText: () => () =>
      i18next.t('accepted_files.excel_only', { ns: 'general' }),
    getMaxDocSize: (state) => state.maxDocSize,
    getMaxDownloadableFileSize: (state) => state.maxDownloadableFileSize,
    getPageSubtitle: (state) => state.pageSubtitle,
    getSecondaryBackButtonTo: (state) => state.secondaryBackButtonTo,
    getProfilePictureUrl: (state, getters) => (url) => url ? `${getters.getRootURL()}/${url}` : '',
    getRemoteResponsiveImage: () => {
      return (imageData, breakpoint) => {
        return getRemoteResponsiveImage(imageData, breakpoint);
      };
    },
    getCurrentRoute: (state) => state.currentRoute,
    immediateYears: () => {
      const currentYear = new Date().getFullYear();
      const previousYears = [1, 2, 3].map((num) => currentYear - num);
      const futureYears = [1, 2, 3].map((num) => currentYear + num);
      return sortBy([currentYear, ...previousYears, ...futureYears]);
    },
    yearsForSelect: (state, getters) => {
      return getters.immediateYears.map((year) => ({ text: year, value: year }));
    },
    getTopActionsOptions: (state) => state.topActionsOptions,

    reportingPeriodOptions() {
      return [
        { text: '1 Month', value: 1 },
        { text: '2 Months', value: 2 },
        { text: '3 Months', value: 3 },
        { text: '6 Months', value: 6 },
        { text: '9 Months', value: 9 },
        { text: '12 Months', value: 12 },
        { text: '2 Years', value: 24 },
      ];
    },
    getHttpProgress(state) {
      return state.httpProgress;
    },
    getSocketSessionId(state) {
      return state.socket.socketSession.id;
    },
    getSocketConnectionState(state) {
      return state.socket.isConnected;
    },
  },
  mutations: {
    setDefaultCountry: (state, country) => {
      state.defaultCountry = country;
    },
    setPageSubtitle: (state, payload) => {
      payload = typeof payload !== 'string' || !payload ? null : payload;

      state.pageSubtitle = payload;
    },
    setSecondaryBackButtonTo: (state, payload) => (state.secondaryBackButtonTo = payload),
    setTopActionsOptions: (state, context) => {
      if (context) {
        state.topActionsOptions.visible = context.visible;
        state.topActionsOptions.options = context.options;
      } else {
        state.topActionsOptions.visible = false;
        state.topActionsOptions.options = undefined;
      }
    },
    setOnlinePresence: (state, payload) => (state.onlinePresence = payload),
    setCurrentYear(state, year) {
      state.currentYear = year;
    },
    setBuildVersion(state, payload) {
      state.buildVersion = payload;
    },
    setCurrentRoute(state, payload) {
      state.currentRoute = payload;
    },
    setDownloadProgress(state, payload) {
      state.httpProgress.download = payload;
    },
    setUploadProgress(state, payload) {
      state.httpProgress.upload = payload;
    },
    setSocketSessionId(state, id) {
      state.socket.socketSession.id = id;
    },
    setSocketConnectionState(state, isConnected) {
      state.socket.isConnected = isConnected;
    },
    setHasJoinedGlobalAdminsRoom(state, value) {
      state.hasJoinedGlobalAdminsRoom = value;
    },
  },

  modules: {
    auth,
    users,
    roles,
    permissions,
    logs,
    visitors,
    user_profiles,
    genders,
    countries,
    membership_manners,
    positions,
    statuses,
    zones,
    marital_statuses,
    ministries,
    organisations,
    services,
    heard_about_us_from,
    service_types,
    service_activities_templates,
    sidebar,
    vue_tables,
    onboardings,
    weekdays,
    giving_types,
    organisation_tasks,
    files,
    system_settings,
    head_count_types,
    service_activities,
    notifications,
    alerts,
    denominations,
    rosters,
    membership_self_registrations,
    sms,
    payments,
    groups,
    organisation_dashboard,
    preferences,
    live_chats,
    screen,
    follow_ups,
    financial_approvals,
    financial_periods,
    financial_budgets,
    financial_requests,
    branch_management,
    membership_requests,
    followers,
    fundraisings,
    posts,
    gotedoEditor,
    formCaches,
    wellKnown,
    subscription,
  },
  plugins: [
    createPersistedState({
      key: 'gotedo-state',
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
    /* StoreMediator, */
  ],
});

export default store;
